import { storeToRefs } from 'pinia';
import Segment from '../Segment';
import { useChallengeStore } from '../stores/challenge';
import { useRiseupAccountStore } from '../stores/riseupAccount';

const joinChallengeVisitedKey = 'riseup.joinChallengeVisited';

const useTrackDashboardVisit = () => {
  const challengeStore = useChallengeStore();
  const riseupAccountStore = useRiseupAccountStore();
  const { hasActiveCashflow } = storeToRefs(riseupAccountStore);

  const markJoinChallengeVisited = () => localStorage.setItem(joinChallengeVisitedKey, 'true');
  const trackDashboardVisitedEvent = (eventName: string) => {
    Segment.trackUserGot(eventName, {
      challengeId: challengeStore.challenge.challengeId,
      firstTimeVisit: !!localStorage.getItem(joinChallengeVisitedKey),
      hasActiveCashflow: hasActiveCashflow.value,
    });
    localStorage.removeItem(joinChallengeVisitedKey);
  };

  return { markJoinChallengeVisited, trackDashboardVisitedEvent };
};
export default useTrackDashboardVisit;
